import moment from 'moment'

class ValidadorDatas {

    validar(licitacao) {
        const validacao = {valido: false, mensagem: ''}
        if (!this._validarDataFimEnvioPropostaAposInicioEnvio(licitacao)) {
            validacao.mensagem = 'A Data/Hora Fim Envio de Propostas não pode ser anterior a Data/Hora Início Envio de Propostas.'
            return validacao
        }
        if (!this._validarDataAberturaAposFimEnvioPropostas(licitacao)) {
            validacao.mensagem = 'A Data/Hora Abertura Licitação não pode ser anterior a Data/Hora Fim Envio de Propostas.'
            return validacao
        }
        if (this._validarDataInicioEnvioPropostasComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora de Início Envio de Propostas não pode ser anterior a data atual.'
            return validacao
        }
        if (this._validarDataInicioEnvioPropostasComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora de Início Envio de Propostas não pode ser anterior a data atual.'
            return validacao
        }
        if (this._validarDataFimEnvioPropostasComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora de Fim Envio de Propostas não pode ser anterior a data atual.'
            return validacao
        }
        if (this._validarDataDeAberturaComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora de Abertura não pode ser anterior a data atual.'
            return validacao
        }
        if (this._validarDataLimiteEsclarecimentoImpugnacaoComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora limite de Esclarecimento/Impugnação não pode ser anterior a data atual.'
            return validacao
        }
        validacao.valido = true
        return validacao
    }

    _validarDataAberturaAposFimEnvioPropostas(licitacao) {
        const dataAbertura = moment(licitacao.dataAbertura)
        const dataFimEnvio = moment(licitacao.dataFimEnvioProposta)
        return dataAbertura.isAfter(dataFimEnvio)
    }

    _validarDataFimEnvioPropostaAposInicioEnvio(licitacao) {
        const dataInicioEnvio = moment(licitacao.dataIniEnvioProposta)
        const dataFimEnvio = moment(licitacao.dataFimEnvioProposta)
        return dataFimEnvio.isAfter(dataInicioEnvio)
    }

    _validarDataInicioEnvioPropostasComDataAtual(licitacao) {
        const dataIniEnvioProposta = moment(licitacao.dataIniEnvioProposta)
        const dataAtual = moment().set('hour', 23).set('minute', 59).set('second', 59).subtract(1, 'days')
        return dataIniEnvioProposta.isBefore(dataAtual)
    }

    _validarDataFimEnvioPropostasComDataAtual(licitacao) {
        const dataFimEnvioProposta = moment(licitacao.dataFimEnvioProposta)
        const dataAtual = moment().set('hour', 23).set('minute', 59).set('second', 59).subtract(1, 'days')
        return dataFimEnvioProposta.isBefore(dataAtual)
    }

    _validarDataDeAberturaComDataAtual(licitacao) {
        const dataAbertura = moment(licitacao.dataAbertura)
        const dataAtual = moment().set('hour', 23).set('minute', 59).set('second', 59).subtract(1, 'days')
        return dataAbertura.isBefore(dataAtual)
    }

    _validarDataLimiteEsclarecimentoImpugnacaoComDataAtual(licitacao) {
        const dataLimiteEsclarecimentoImpugnacao = moment(licitacao.dataLimiteEsclarecimentoImpugnacao)
        if(!dataLimiteEsclarecimentoImpugnacao) return false
        const dataAtual = moment().set('hour', 23).set('minute', 59).set('second', 59).subtract(1, 'days')
        return dataLimiteEsclarecimentoImpugnacao.isBefore(dataAtual)
    }

}

export default new ValidadorDatas()
